import jobs from './apis/jobsearch-api';

// Create a singleton instance of the API client
let instance: { jobs: typeof jobs } | null;

/**
 * Create and return a singleton API client
 *
 * This ensures that only one instance of the API client is created
 * and reused throughout the application
 */
export default () => {
  if (!instance) {
    instance = {
      jobs,
    };
  }

  return instance;
};
